import {
  SET_AIR_RESULTS,
  SELECT_AIR,
  ORDER_BY_AIR,
  ORDER_BY_REVERSE_AIR,
  FILTER_BY_AIR,
  FILTER_BY_AIR_BRAND,
  FILTER_BY_AIR_STOP_AND_VENDOR,
  CLEAR_AIR,
} from '../actions/air';
import { orderByAirList } from '../../constants/orderByLists';
import { airBrandMap } from '../../constants/BrandMaps';

const initialState = {
  components: {},
};

// const initialState = {
//   searchResults: null,
//   orderBy: null,
//   filterBy: null,
//   filterByBrand: null,
//   reverse: false,
//   selectedAir: [],
//   filterByDetails: null,
//   filterBrands: null,
// };

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AIR_RESULTS:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterBy: 'ALL',
            filterByBrand: action.filterByBrand || Object.keys(airBrandMap)[0],
            filterByDetails: null,
            orderBy: orderByAirList[0].value,
            reverse: false,
            filterBrands: action.filterBrands,
            searchResults: action.searchResults?.data
              ? action.searchResults?.data
              : action.searchResults,
          },
        },
      };
    case SELECT_AIR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            selectedAir: action.selectedAir,
            newMultiBrandResponseKey: action.brand.MultiBrandID
              ? action.brand.MultiBrandID
              : action.brand.id,
          },
        },
      };
    case ORDER_BY_AIR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            orderBy: action.orderBy,
            reverse: action.reverse,
          },
        },
      };
    case ORDER_BY_REVERSE_AIR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            reverse: action.reverse,
          },
        },
      };
    case FILTER_BY_AIR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterBy: action.filterBy,
          },
        },
      };
    case FILTER_BY_AIR_BRAND:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterByBrand: action.filterByBrand,
          },
        },
      };
    case FILTER_BY_AIR_STOP_AND_VENDOR:
      return {
        ...state,
        components: {
          ...state.components,
          [action.displayIndex]: {
            ...state.components[action.displayIndex],
            filterByDetails: action.filterByDetails,
          },
        },
      };
    case CLEAR_AIR:
      return {
        ...state,
        components: {},
      };
    default:
      return state;
  }
};
